import SmoothScrollProvider from "./components/SmoothScrollProvider";
import TrustedIndustries from './components/sections/TrustedIndustries'
import HomeSection from './components/sections/HomeSection'
import TopNav from './components/sections/TopNav'
import MainVideoSection from './components/sections/MainVideoSection'
import BrandTrustTransparency from './components/sections/BrandTrustTransparency'
import JoinElystrionSection from './components/sections/JoinElystrionSection'
import VerifyProductSection from './components/sections/VerifyProductSection'
import TestimonialsSection from './components/sections/TestimonialsSection'
import FAQSection from './components/sections/FAQSection'
import FooterSection from './components/sections/FooterSection'
import VerificationOption from "./components/sections/VerificationOption";
import PreLoader from "./components/sections/PreLoader";
import { useEffect, useState } from "react";

export default function App() {
  const [isContentLoaded, setIsContentLoaded] = useState(false);
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  const [isPreLoaded, setPreLoaded] = useState(false);
  const [videoSource, setVideoSource] = useState(null);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const videoUrl = process.env.REACT_APP_HOME_VIDEO

  useEffect(() => {
    getHomeVideo();
  }, []);

  const getHomeVideo = async () => {
    setIsVideoLoaded(false);
    const cache = await caches.open("video-cache");
    const cachedResponse = await cache.match(videoUrl);

    if (cachedResponse) {
      console.log("✅ Loaded video from cache");
      setDownloadProgress(50);
      const blob = await cachedResponse.blob();
      setTimeout(() => {
        setDownloadProgress(75);
      }, 1000); // small delay before marking loaded

      setTimeout(() => {
        const url = URL.createObjectURL(blob);
        setVideoSource(url);
        // final step
        setDownloadProgress(100);
      }, 2000); // small delay before marking loaded

      setTimeout(() => {
        setIsVideoLoaded(true);
      }, 3000); // small delay before marking loaded
      return;
    }

    console.log("⬇️ Fetching fresh video with progress...");

    try {
      const response = await fetch(videoUrl);

      if (!response.ok || !response.body) {
        throw new Error("Failed to fetch video or stream not supported");
      }

      const contentLength = response.headers.get("content-length");
      if (!contentLength) {
        console.warn("⚠️ Content-Length not available, can’t show progress");
      }

      const total = parseInt(contentLength, 10);
      let loaded = 0;

      const reader = response.body.getReader();
      const chunks = [];

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        chunks.push(value);
        loaded += value.length;

        if (total) {
          const percent = ((loaded / total) * 100).toFixed(0);
          setDownloadProgress(percent);
        }
      }

      const blob = new Blob(chunks);
      await cache.put(videoUrl, new Response(blob));

      const url = URL.createObjectURL(blob);
      setVideoSource(url);
      setIsVideoLoaded(true);
    } catch (error) {
      setDownloadProgress(100);
      setIsVideoLoaded(true);
    }
  };


  useEffect(() => {
    if (isPreLoaded && isVideoLoaded) {
      setIsContentLoaded(true);
    }
  }, [isPreLoaded, isVideoLoaded]);

  return (
    // <SmoothScrollProvider>
    <>
      {!isContentLoaded && (
        <PreLoader setIsContentLoaded={setPreLoaded} isVideoLoaded={isVideoLoaded} downloadProgress={downloadProgress} />
      )}
      <div className={`${isContentLoaded ? "block min-h-screen bg-[#0A0A0A]" : "hidden"}`}>
        <TopNav />
        <HomeSection isContentLoaded={isContentLoaded} videoSource={videoSource} />
        <MainVideoSection />
        <BrandTrustTransparency />
        <TrustedIndustries />
        <JoinElystrionSection />
        <VerifyProductSection />
        {/* <TestimonialsSection /> */}
        <FAQSection />
        <FooterSection />
      </div>
    </>
    /* </SmoothScrollProvider> */
  );
}